import React, { forwardRef } from "react";
import styled from "@emotion/styled";

import UIcon from "../../../lib/icons/untitled_ui/UIcon";

interface AlertProps {
  children: React.ReactNode;
  type: "info" | "warning" | "error";
}

const Alert = forwardRef<HTMLDivElement, AlertProps>(({ type, children, ...props }, ref) => (
  <Wrapper type={type}>
    <UIcon icon="infoCircle" size={20} className="icon" />
    <div ref={ref} {...props}>
      {children}
    </div>
  </Wrapper>
));

const Wrapper = styled.div<{ type: AlertProps["type"] }>(({ theme, type }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  padding: "8px 12px",
  gap: "10px",
  borderRadius: "4px",
  color: theme.colors.sysTextDefault,

  ...(type === "info" && {
    backgroundColor: theme.colors.sysInfoSubtle,
    ["& .icon"]: {
      color: theme.colors.sysInfoSubtle,
      fill: theme.colors.sysInfoDefault,
    },
  }),
  ...(type === "warning" && {
    backgroundColor: theme.colors.sysWarningSubtle,
    ["& .icon"]: {
      color: theme.colors.sysWarningSubtle,
      fill: theme.colors.sysWarningDefault,
    },
  }),
  ...(type === "error" && {
    backgroundColor: theme.colors.sysDestructiveSubtle,
    ["& .icon"]: {
      color: theme.colors.sysDestructiveSubtle,
      fill: theme.colors.sysDestructiveDefault,
    },
  }),
}));

Alert.displayName = "Alert";

export default Alert;
